(function () {
  const MILESTONES = [10, 25, 50, 75];
  const meta = {};
  let last = null;

  const key = (url) => {
    try { return decodeURIComponent(new URL(url, location.href).pathname.split('/').pop()); }
    catch (e) { return ''; }
  };

  document.addEventListener('click', function (e) {
    const el = e.target.closest('.mvcf-featured-video__play');
    if (!el) return;

    const data = {
      video_title: el.dataset.videoTitle || 'Untitled',
      video_type: el.dataset.videoType || 'file',
      video_url: el.getAttribute('href') || ''
    };

    last = key(data.video_url);
    if (last) meta[last] = data;

    if (typeof gtag === 'function') gtag('event', 'featured_video_play', data);
  });

  function lookup(video) {
    return meta[key(video.currentSrc)] || (last && meta[last]) || { video_title: document.title };
  }

  function send(name, video, extra) {
    if (typeof gtag !== 'function') return;
    gtag('event', name, Object.assign({}, lookup(video), {
      video_duration: Math.round(video.duration) || 0,
      video_current_time: Math.round(video.currentTime)
    }, extra || {}));
  }

  document.addEventListener('play', function (e) {
    const video = e.target;
    if (!(video instanceof HTMLVideoElement)) return;

    if (!video._mvcfBound) {
      video._mvcfBound = true;
      video._mvcfHit = new Set();

      video.addEventListener('timeupdate', function () {
        if (!video.duration) return;
        const pct = (video.currentTime / video.duration) * 100;
        MILESTONES.forEach(function (m) {
          if (pct >= m && !video._mvcfHit.has(m)) {
            video._mvcfHit.add(m);
            send('featured_video_progress', video, { video_percent: m });
          }
        });
      });

      video.addEventListener('ended', function () {
        send('featured_video_complete', video, { video_percent: 100 });
        video._mvcfHit.clear();
      });
    }

    if (video.currentTime < 1) {
      video._mvcfHit.clear();
      send('featured_video_start', video);
    }
  }, true);
})();

